import {defaultState} from "./state";

const mutations = {
  UPDATE_UNPUBLISH_PAGE_LIST: (state, {type, pageId, version}) => {
    const unpublishList = state.pages[type].unpublishList[version];
    if (unpublishList.includes(pageId)) {
      const currentPageIndex = unpublishList.indexOf(pageId);
      return unpublishList.splice(currentPageIndex, 1);
    } else {
      unpublishList.push(pageId);
    }
  },
  SET_SELECT_ALL: (state, {pageType, pageList}) => {
    const list = pageList.map((page) => ({
      id: page.id,
      version: page.isTemplateV7 ? 'v7' : 'v6'
    }));

    const { v6: listV6, v7: listV7 } = state.pages[pageType].unpublishList;

    const unpublishList = [...listV6, ...listV7];
    const isSelectAll = list.every(page => unpublishList.includes(page.id));

    list.map(page => {
      const list = state.pages[pageType].unpublishList[page.version];

      if (isSelectAll) {
        const currentProductIndex = list.indexOf(page.id);
        return list.splice(currentProductIndex, 1);
      }

      list.push(page.id);
    });
  },
  RESET_SELECT_PAGE: (state, pageType) => {
    state.pages[pageType].unpublishList.v7 = [];
    state.pages[pageType].unpublishList.v6 = [];
  },
  RESET_DATA: (state) => {
    return Object.assign(state, defaultState());
  },
  SET_DISABLED_CONFIRM: (state, value) => {
    state.disabledConfirm = value;
  },
  SET_CHOOSED_PLAN: (state, value) => {
    state.choosedPlan = value;
  },
  PAGE_UPDATE_QUERY: (state, {type, value}) => {
    state.pages[type].query = value;
  },
  OPEN_UNPUBLISH_MODAL: (state, type) => {
    state.unpublishPageType = type;
    state.isOpenUnpublishModal = true;
  },
  CLOSE_UNPUBLISH_MODAL: (state) => {
    state.isOpenUnpublishModal = false;
  },
  TOGGLE_BLOCK_MODAL: (state, value) => {
    state.openBlockModal = value;
  }
};
export default mutations;
